// extracted by mini-css-extract-plugin
export default {"root":"TransactionHistoryTable_root__sH5Nw","colored":"TransactionHistoryTable_colored__0fcci"};